import { ClientUser } from "./client-user";
import { SmeUserDetail } from "./get-all-users-response.model";

export class EmailPopupData {
  engagementId: number;
  SurveyId: number[];
  SME: number[];
  requestTemplateType: number
  surveyType: number;
  surveyScreenType: number;
  deletedList: string;
  isWelcomeEmail: number = 0;
  SMEList: ClientUser[];
  sendToAll: boolean = false;
  SMEOptional: SmeUserDetail[];
}

export class TemplateRequest {
  engagementId: number;
  SurveyId: number[];
  SME: number[];
  surveyType: number;
  requestTemplateType: number;
  modifiedTemplates: ModifiedSMETemplates[];
  sendToAll: boolean = false;
}
export class ModifiedSMETemplates {
  smeId: number;
  emailSubject: string;
  emailContent: string;
}

export class UseAsAutoReminderEmailDto {
  templateId: number;
  engagementId: number;
  isAuto: boolean;
}

export interface EmailDefaultCcDto {
  userIds: number[];
  engagementId: number;
}

export class EmailCCList {
  userName: string;
  displayName: string;
  userId: number;
}

export class SendEmailRequest {
  engagementId: number;
  SmeIds: number[];
  deletedSmeIds: string;
  SurveyIds: number[];
  ccList: EmailCCList[];
  surveyType: number;
  emailSubject: string;
  emailContent: string;
  emailType: string;
  surveyScreenType: number;
  isEmailSentToAllSme: boolean;
  isPreviewEmail: boolean;
}

export class CustomTemplateRequest {
  id: number;
  engagementId: number;
  name: string;
  template: string;
  templateType: number;
  surveyCategoryId: number;
  isAutoReminderTemplate: boolean;
}

export class AssignSmeTemplateDto {
  subject: string;
  emailContent: string;
  isReminderEnabled: boolean;
  ccList: ClientUser[];
  smeList: ClientUser[];
  customEmailTemplatesList: CustomEmailTemplateDto[];
}

export class CustomEmailTemplateDto {
  id: number;
  engagementId: number;
  name: string;
  path: string;
  templateType: number;
  surveyCategoryId: number;
  isAutoReminderTemplate: boolean
}
